module.exports = __webpack_public_path__ + "img/code.073b44eb.png";